import { Dialog, DialogContent } from '@rocco/components/dialog';
import {
    ClientDirectorBookingPanel,
    type BookingPrefill,
} from './ClientDirectorBookingPanel';

interface ClientDirectorBookingModalProps {
    /** The Client Director CalendarSession to book against. */
    sessionId: number;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    /** Seeds the confirmation step (name / email / company). */
    prefill?: BookingPrefill;
    /** Extra fields posted with the booking, e.g. a linked `enquiryId`. */
    extraFormFields?: Record<string, string>;
}

/**
 * In-page booking modal for a project's linked Client Director session. Wraps
 * {@link ClientDirectorBookingPanel} in a dialog so the experience matches the
 * standalone /booking page without leaving the detail page.
 */
export const ClientDirectorBookingModal = ({
    sessionId,
    open,
    onOpenChange,
    prefill,
    extraFormFields,
}: ClientDirectorBookingModalProps) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-h-[90vh] w-full overflow-y-auto p-0 sm:w-auto sm:max-w-[unset]">
            <ClientDirectorBookingPanel
                sessionId={sessionId}
                active={open}
                prefill={prefill}
                extraFormFields={extraFormFields}
            />
        </DialogContent>
    </Dialog>
);
